import { Wallet, GraduationCap, Users, Leaf, Briefcase, Globe, Home, Heart, Baby, Coins, ShoppingBag } from 'lucide-react';

export const FEDERAL_TAX_BRACKETS = {
  single: [
    { rate: 0.10, threshold: 0 },
    { rate: 0.12, threshold: 11600 },
    { rate: 0.22, threshold: 47150 },
    { rate: 0.24, threshold: 100525 },
    { rate: 0.32, threshold: 191950 },
    { rate: 0.35, threshold: 243725 },
    { rate: 0.37, threshold: 609350 }
  ],
  joint: [
    { rate: 0.10, threshold: 0 },
    { rate: 0.12, threshold: 23200 },
    { rate: 0.22, threshold: 94300 },
    { rate: 0.24, threshold: 201050 },
    { rate: 0.32, threshold: 383900 },
    { rate: 0.35, threshold: 487450 },
    { rate: 0.37, threshold: 731200 }
  ],
  head: [
    { rate: 0.10, threshold: 0 },
    { rate: 0.12, threshold: 16550 },
    { rate: 0.22, threshold: 63100 },
    { rate: 0.24, threshold: 100500 },
    { rate: 0.32, threshold: 191950 },
    { rate: 0.35, threshold: 243700 },
    { rate: 0.37, threshold: 609350 }
  ]
};

export const STATE_TAX_RATES = [
  { state: 'Alabama', rate: 5.0, notes: 'Progressive, 2-5%' },
  { state: 'Alaska', rate: 0.0, notes: 'No state income tax' },
  { state: 'Arizona', rate: 2.5, notes: 'Flat rate' },
  { state: 'Arkansas', rate: 4.7, notes: 'Progressive, 2-4.7%' },
  { state: 'California', rate: 13.3, notes: 'Progressive, 1-13.3%' },
  { state: 'Colorado', rate: 4.4, notes: 'Flat rate' },
  { state: 'Connecticut', rate: 6.99, notes: 'Progressive, 3-6.99%' },
  { state: 'Delaware', rate: 6.6, notes: 'Progressive, 2.2-6.6%' },
  { state: 'Florida', rate: 0.0, notes: 'No state income tax' },
  { state: 'Georgia', rate: 5.29, notes: 'Progressive, transitioning to flat rate' },
  { state: 'Hawaii', rate: 11.0, notes: 'Progressive, 1.4-11%' },
  { state: 'Idaho', rate: 5.8, notes: 'Progressive, 1-5.8%' },
  { state: 'Illinois', rate: 4.95, notes: 'Flat rate' },
  { state: 'Indiana', rate: 3.15, notes: 'Flat rate' },
  { state: 'Iowa', rate: 3.9, notes: 'Flat rate by 2025' },
  { state: 'Kansas', rate: 5.7, notes: 'Progressive, 3.1-5.7%' },
  { state: 'Kentucky', rate: 4.0, notes: 'Flat rate' },
  { state: 'Louisiana', rate: 4.25, notes: 'Progressive, 1.85-4.25%' },
  { state: 'Maine', rate: 7.15, notes: 'Progressive, 5.8-7.15%' },
  { state: 'Maryland', rate: 5.75, notes: 'Progressive, 2-5.75%' },
  { state: 'Massachusetts', rate: 5.0, notes: 'Flat rate' },
  { state: 'Michigan', rate: 4.25, notes: 'Flat rate' },
  { state: 'Minnesota', rate: 9.85, notes: 'Progressive, 5.35-9.85%' },
  { state: 'Mississippi', rate: 5.0, notes: 'Flat rate' },
  { state: 'Missouri', rate: 4.95, notes: 'Progressive, 1.5-4.95%' },
  { state: 'Montana', rate: 6.75, notes: 'Progressive, 1-6.75%' },
  { state: 'Nebraska', rate: 5.84, notes: 'Progressive, reducing rates by 2025' },
  { state: 'Nevada', rate: 0.0, notes: 'No state income tax' },
  { state: 'New Hampshire', rate: 5.0, notes: 'Only taxes interest and dividends' },
  { state: 'New Jersey', rate: 10.75, notes: 'Progressive, 1.4-10.75%' },
  { state: 'New Mexico', rate: 5.9, notes: 'Progressive, 1.7-5.9%' },
  { state: 'New York', rate: 10.9, notes: 'Progressive, 4-10.9%' },
  { state: 'North Carolina', rate: 4.75, notes: 'Flat rate' },
  { state: 'North Dakota', rate: 2.9, notes: 'Progressive, 1.1-2.9%' },
  { state: 'Ohio', rate: 3.75, notes: 'Progressive, 2.75-3.75%' },
  { state: 'Oklahoma', rate: 4.75, notes: 'Progressive, 0.25-4.75%' },
  { state: 'Oregon', rate: 9.9, notes: 'Progressive, 4.75-9.9%' },
  { state: 'Pennsylvania', rate: 3.07, notes: 'Flat rate' },
  { state: 'Rhode Island', rate: 5.99, notes: 'Progressive, 3.75-5.99%' },
  { state: 'South Carolina', rate: 6.5, notes: 'Progressive, reducing rates by 2025' },
  { state: 'South Dakota', rate: 0.0, notes: 'No state income tax' },
  { state: 'Tennessee', rate: 0.0, notes: 'No state income tax' },
  { state: 'Texas', rate: 0.0, notes: 'No state income tax' },
  { state: 'Utah', rate: 4.65, notes: 'Flat rate' },
  { state: 'Vermont', rate: 8.75, notes: 'Progressive, 3.35-8.75%' },
  { state: 'Virginia', rate: 5.75, notes: 'Progressive, 2-5.75%' },
  { state: 'Washington', rate: 0.0, notes: 'No state income tax' },
  { state: 'West Virginia', rate: 6.5, notes: 'Progressive, 3-6.5%' },
  { state: 'Wisconsin', rate: 7.65, notes: 'Progressive, 3.54-7.65%' },
  { state: 'Wyoming', rate: 0.0, notes: 'No state income tax' }
];

export const RETIREMENT_ACCOUNTS = {
  traditional401k: {
    label: 'Traditional 401(k)',
    limit: 23000,
    catchup: 7500,
    catchupAge: 50,
    employerMatch: true,
    taxAdvantage: 'pre-tax',
    description: 'Contributions reduce taxable income. Withdrawals taxed as ordinary income in retirement.'
  },
  roth401k: {
    label: 'Roth 401(k)',
    limit: 23000,
    catchup: 7500,
    catchupAge: 50,
    employerMatch: true,
    taxAdvantage: 'after-tax',
    description: 'Contributions made with after-tax dollars. Qualified withdrawals tax-free in retirement.'
  },
  traditionalIRA: {
    label: 'Traditional IRA',
    limit: 7000,
    catchup: 1000,
    catchupAge: 50,
    employerMatch: false,
    taxAdvantage: 'pre-tax',
    incomeLimit: {
      single: 87000,
      joint: 143000
    },
    description: 'Tax-deductible contributions if income below limits. Withdrawals taxed as ordinary income.'
  },
  rothIRA: {
    label: 'Roth IRA',
    limit: 7000,
    catchup: 1000,
    catchupAge: 50,
    employerMatch: false,
    taxAdvantage: 'after-tax',
    incomeLimit: {
      single: 153000,
      joint: 242000
    },
    description: 'Contributions made with after-tax dollars. Qualified withdrawals tax-free in retirement.'
  },
  sepIRA: {
    label: 'SEP IRA',
    limit: 69000,
    catchup: 0,
    catchupAge: null,
    employerMatch: false,
    taxAdvantage: 'pre-tax',
    description: 'For self-employed and small business owners. Contributions tax-deductible.'
  },
  simpleIRA: {
    label: 'SIMPLE IRA',
    limit: 16000,
    catchup: 3500,
    catchupAge: 50,
    employerMatch: true,
    taxAdvantage: 'pre-tax',
    description: 'For small businesses (< 100 employees). Employer required to contribute.'
  }
};

export const CATEGORY_COLORS = {
  needs: {
    border: 'border-emerald-500',
    text: 'text-emerald-500',
    light: 'bg-emerald-500/10',
    hover: 'hover:bg-emerald-500/5',
    fill: '#10b981'
  },
  wants: {
    border: 'border-green-400',
    text: 'text-green-400',
    light: 'bg-green-400/10',
    hover: 'hover:bg-green-400/5',
    fill: '#34d399'
  },
  savings: {
    border: 'border-green-500',
    text: 'text-green-500',
    light: 'bg-green-500/10',
    hover: 'hover:bg-green-500/5',
    fill: '#22c55e'
  }
};

export const TAX_DEDUCTIONS = {
  standard: {
    single: 13850,
    joint: 27700,
    head: 20800
  },
  retirement: {
    traditional401k: {
      label: 'Traditional 401(k)',
      limit: 23000,
      catchup: 7500,
      catchupAge: 50,
      employerMatch: true,
      taxAdvantage: 'pre-tax'
    },
    roth401k: {
      label: 'Roth 401(k)',
      limit: 23000,
      catchup: 7500,
      catchupAge: 50,
      employerMatch: true,
      taxAdvantage: 'after-tax'
    },
    traditionalIRA: {
      label: 'Traditional IRA',
      limit: 7000,
      catchup: 1000,
      catchupAge: 50,
      employerMatch: false,
      taxAdvantage: 'pre-tax',
      incomeLimit: {
        single: 87000,
        joint: 143000
      }
    },
    rothIRA: {
      label: 'Roth IRA',
      limit: 7000,
      catchup: 1000,
      catchupAge: 50,
      employerMatch: false,
      taxAdvantage: 'after-tax',
      incomeLimit: {
        single: 153000,
        joint: 242000
      }
    },
    sep: {
      label: 'SEP IRA',
      limit: 69000,
      catchup: 0,
      catchupAge: null,
      employerMatch: false,
      taxAdvantage: 'pre-tax'
    },
    simple: {
      label: 'SIMPLE IRA',
      limit: 16000,
      catchup: 3500,
      catchupAge: 50,
      employerMatch: true,
      taxAdvantage: 'pre-tax'
    }
  },
  itemized: {
    mortgage: { label: 'Mortgage Interest', max: 750000 },
    charity: { label: 'Charitable Contributions', max: null },
    medical: { label: 'Medical Expenses', threshold: 0.075 },
    state: { label: 'State & Local Taxes', max: 10000 },
    student: { label: 'Student Loan Interest', max: 2500 }
  }
};

export const TAX_CREDITS = {
  child: {
    amount: 2000,
    income_limit: {
      single: 200000,
      joint: 400000,
      head: 200000
    }
  },
  childcare: {
    max: 3000,
    percentage: 0.35
  },
  education: {
    aotc: {
      max: 2500,
      income_limit: {
        single: 90000,
        joint: 180000,
        head: 90000
      }
    },
    llc: {
      max: 2000,
      income_limit: {
        single: 80000,
        joint: 160000,
        head: 80000
      }
    }
  },
  retirement: {
    max: 1000,
    income_limit: {
      single: 36500,
      joint: 73000,
      head: 54750
    }
  },
  energy: {
    solar: {
      percentage: 0.30
    },
    ev: {
      max: 7500
    }
  }
};

export const BUDGET_TEMPLATES = {
  'student': {
    name: 'Student Budget',
    icon: GraduationCap,
    description: 'A budget tailored for students with common expenses.',
    fieldDescriptions: {
      needs: 'Tuition, rent, textbooks',
      wants: 'Entertainment, eating out',
      savings: 'Emergency fund, future investments'
    },
    expenses: [
      { id: '1', name: 'Rent', amount: 800, category: 'needs' },
      { id: '2', name: 'Tuition', amount: 1200, category: 'needs' },
      { id: '3', name: 'Textbooks', amount: 200, category: 'needs' },
      { id: '4', name: 'Groceries', amount: 300, category: 'needs' },
      { id: '5', name: 'Transportation', amount: 100, category: 'needs' },
      { id: '6', name: 'Internet', amount: 50, category: 'needs' },
      { id: '7', name: 'Phone Plan', amount: 40, category: 'needs' },
      { id: '8', name: 'School Supplies', amount: 30, category: 'needs' },
      { id: '9', name: 'Entertainment', amount: 100, category: 'wants' },
      { id: '10', name: 'Eating Out', amount: 150, category: 'wants' },
      { id: '11', name: 'Streaming Services', amount: 15, category: 'wants' },
      { id: '12', name: 'Hobbies', amount: 50, category: 'wants' },
      { id: '13', name: 'Campus Activities', amount: 30, category: 'wants' },
      { id: '14', name: 'Emergency Fund', amount: 100, category: 'savings' },
      { id: '15', name: 'Future Textbooks', amount: 50, category: 'savings' },
      { id: '16', name: 'Summer Savings', amount: 50, category: 'savings' }
    ]
  },
  '50_30_20': {
    name: '50/30/20 Budget',
    icon: Wallet,
    description: 'A balanced budget allocating 50% to needs, 30% to wants, and 20% to savings.',
    fieldDescriptions: {
      needs: 'Housing, utilities, groceries',
      wants: 'Entertainment, dining out, hobbies',
      savings: 'Investments, debt repayment, emergency fund'
    },
    expenses: [
      { id: '17', name: 'Rent/Mortgage', amount: 1200, category: 'needs' },
      { id: '18', name: 'Utilities', amount: 200, category: 'needs' },
      { id: '19', name: 'Groceries', amount: 500, category: 'needs' },
      { id: '20', name: 'Car Payment', amount: 300, category: 'needs' },
      { id: '21', name: 'Insurance', amount: 150, category: 'needs' },
      { id: '22', name: 'Phone & Internet', amount: 120, category: 'needs' },
      { id: '23', name: 'Healthcare', amount: 200, category: 'needs' },
      { id: '24', name: 'Entertainment', amount: 200, category: 'wants' },
      { id: '25', name: 'Dining Out', amount: 300, category: 'wants' },
      { id: '26', name: 'Shopping', amount: 200, category: 'wants' },
      { id: '27', name: 'Hobbies', amount: 150, category: 'wants' },
      { id: '28', name: 'Gym', amount: 50, category: 'wants' },
      { id: '29', name: 'Travel Fund', amount: 100, category: 'wants' },
      { id: '30', name: 'Retirement', amount: 400, category: 'savings' },
      { id: '31', name: 'Emergency Fund', amount: 200, category: 'savings' },
      { id: '32', name: 'Investment Account', amount: 200, category: 'savings' }
    ]
  },
  'travel': {
    name: 'Travel Budget',
    icon: Globe,
    description: 'A budget focused on saving for travel experiences.',
    fieldDescriptions: {
      needs: 'Essential bills, rent, utilities',
      wants: 'Travel, experiences, dining',
      savings: 'Travel fund, vacation savings'
    },
    expenses: [
      { id: '33', name: 'Rent', amount: 900, category: 'needs' },
      { id: '34', name: 'Utilities', amount: 150, category: 'needs' },
      { id: '35', name: 'Groceries', amount: 350, category: 'needs' },
      { id: '36', name: 'Transportation', amount: 100, category: 'needs' },
      { id: '37', name: 'Phone & Internet', amount: 80, category: 'needs' },
      { id: '38', name: 'Insurance', amount: 100, category: 'needs' },
      { id: '39', name: 'Flights', amount: 400, category: 'wants' },
      { id: '40', name: 'Accommodation', amount: 300, category: 'wants' },
      { id: '41', name: 'Activities', amount: 200, category: 'wants' },
      { id: '42', name: 'Travel Gear', amount: 100, category: 'wants' },
      { id: '43', name: 'Local Experiences', amount: 150, category: 'wants' },
      { id: '44', name: 'Travel Insurance', amount: 50, category: 'wants' },
      { id: '45', name: 'Emergency Travel Fund', amount: 200, category: 'savings' },
      { id: '46', name: 'Next Trip Fund', amount: 400, category: 'savings' },
      { id: '47', name: 'Passport/Visas', amount: 50, category: 'savings' }
    ]
  },
  'minimalist': {
    name: 'Minimalist Budget',
    icon: Leaf,
    description: 'A budget emphasizing essential spending and maximizing savings.',
    fieldDescriptions: {
      needs: 'Essential bills, minimal groceries',
      wants: 'Limited entertainment, basic needs',
      savings: 'Aggressive savings, investments'
    },
    expenses: [
      { id: '48', name: 'Basic Rent', amount: 700, category: 'needs' },
      { id: '49', name: 'Minimal Utilities', amount: 100, category: 'needs' },
      { id: '50', name: 'Basic Groceries', amount: 300, category: 'needs' },
      { id: '51', name: 'Essential Transport', amount: 50, category: 'needs' },
      { id: '52', name: 'Basic Phone Plan', amount: 30, category: 'needs' },
      { id: '53', name: 'Internet', amount: 40, category: 'needs' },
      { id: '54', name: 'Basic Insurance', amount: 80, category: 'needs' },
      { id: '55', name: 'Basic Entertainment', amount: 50, category: 'wants' },
      { id: '56', name: 'Minimal Dining Out', amount: 100, category: 'wants' },
      { id: '57', name: 'Essential Clothing', amount: 50, category: 'wants' },
      { id: '58', name: 'Basic Hobbies', amount: 30, category: 'wants' },
      { id: '59', name: 'Investment Account', amount: 600, category: 'savings' },
      { id: '60', name: 'Emergency Fund', amount: 200, category: 'savings' },
      { id: '61', name: 'Retirement', amount: 400, category: 'savings' }
    ]
  },
  'business': {
    name: 'Business Budget',
    icon: Briefcase,
    description: 'A budget designed for business owners, focusing on reinvestment and growth.',
    fieldDescriptions: {
      needs: 'Operating costs, salaries',
      wants: 'Marketing, business development',
      savings: 'Reinvestment, emergency fund'
    },
    expenses: [
      { id: '62', name: 'Office Rent', amount: 1000, category: 'needs' },
      { id: '63', name: 'Utilities', amount: 200, category: 'needs' },
      { id: '64', name: 'Employee Salaries', amount: 2500, category: 'needs' },
      { id: '65', name: 'Software Subscriptions', amount: 200, category: 'needs' },
      { id: '66', name: 'Insurance', amount: 300, category: 'needs' },
      { id: '67', name: 'Office Supplies', amount: 150, category: 'needs' },
      { id: '68', name: 'Marketing', amount: 500, category: 'wants' },
      { id: '69', name: 'Advertising', amount: 400, category: 'wants' },
      { id: '70', name: 'Professional Development', amount: 200, category: 'wants' },
      { id: '71', name: 'Client Entertainment', amount: 300, category: 'wants' },
      { id: '72', name: 'Business Travel', amount: 400, category: 'wants' },
      { id: '73', name: 'Equipment Upgrades', amount: 300, category: 'wants' },
      { id: '74', name: 'Business Expansion', amount: 1000, category: 'savings' },
      { id: '75', name: 'Emergency Fund', amount: 500, category: 'savings' },
      { id: '76', name: 'Tax Reserve', amount: 800, category: 'savings' }
    ]
  },
  'homeowner': {
    name: 'Homeowner Budget',
    icon: Home,
    description: 'A budget template for homeowners with mortgage and maintenance expenses.',
    fieldDescriptions: {
      needs: 'Mortgage, utilities, maintenance',
      wants: 'Home improvements, furnishings',
      savings: 'Property tax, insurance, repairs'
    },
    expenses: [
      { id: '77', name: 'Mortgage', amount: 1500, category: 'needs' },
      { id: '78', name: 'Property Tax', amount: 400, category: 'needs' },
      { id: '79', name: 'Home Insurance', amount: 150, category: 'needs' },
      { id: '80', name: 'Utilities', amount: 300, category: 'needs' },
      { id: '81', name: 'Internet/Cable', amount: 100, category: 'needs' },
      { id: '82', name: 'HOA Fees', amount: 200, category: 'needs' },
      { id: '83', name: 'Basic Maintenance', amount: 150, category: 'needs' },
      { id: '84', name: 'Lawn Care', amount: 100, category: 'needs' },
      { id: '85', name: 'Home Improvements', amount: 400, category: 'wants' },
      { id: '86', name: 'Furniture', amount: 200, category: 'wants' },
      { id: '87', name: 'Decor', amount: 100, category: 'wants' },
      { id: '88', name: 'Garden/Landscaping', amount: 150, category: 'wants' },
      { id: '89', name: 'Major Repairs Fund', amount: 300, category: 'savings' },
      { id: '90', name: 'Appliance Replacement', amount: 200, category: 'savings' },
      { id: '91', name: 'Home Emergency Fund', amount: 200, category: 'savings' },
      { id: '92', name: 'Future Renovations', amount: 300, category: 'savings' }
    ]
  },
  'healthcare': {
    name: 'Healthcare Focus',
    icon: Heart,
    description: 'A budget prioritizing health-related expenses and medical savings.',
    fieldDescriptions: {
      needs: 'Insurance, medications, regular care',
      wants: 'Wellness activities, supplements',
      savings: 'Medical emergency fund, HSA'
    },
    expenses: [
      { id: '93', name: 'Health Insurance', amount: 400, category: 'needs' },
      { id: '94', name: 'Dental Insurance', amount: 50, category: 'needs' },
      { id: '95', name: 'Vision Insurance', amount: 30, category: 'needs' },
      { id: '96', name: 'Prescriptions', amount: 150, category: 'needs' },
      { id: '97', name: 'Regular Check-ups', amount: 100, category: 'needs' },
      { id: '98', name: 'Specialist Visits', amount: 200, category: 'needs' },
      { id: '99', name: 'Medical Supplies', amount: 100, category: 'needs' },
      { id: '100', name: 'Gym Membership', amount: 50, category: 'wants' },
      { id: '101', name: 'Wellness Classes', amount: 100, category: 'wants' },
      { id: '102', name: 'Supplements', amount: 75, category: 'wants' },
      { id: '103', name: 'Health Foods', amount: 200, category: 'wants' },
      { id: '104', name: 'Fitness Equipment', amount: 50, category: 'wants' },
      { id: '105', name: 'HSA Contributions', amount: 300, category: 'savings' },
      { id: '106', name: 'Medical Emergency', amount: 200, category: 'savings' },
      { id: '107', name: 'Future Procedures', amount: 150, category: 'savings' },
      { id: '108', name: 'Dental/Vision Fund', amount: 100, category: 'savings' }
    ]
  },
  'family': {
    name: 'Family Budget',
    icon: Users,
    description: 'A comprehensive budget for families with children.',
    fieldDescriptions: {
      needs: 'Housing, childcare, education',
      wants: 'Family activities, hobbies',
      savings: 'College fund, family emergency fund'
    },
    expenses: [
      { id: '109', name: 'Housing', amount: 2000, category: 'needs' },
      { id: '110', name: 'Childcare', amount: 800, category: 'needs' },
      { id: '111', name: 'School Tuition', amount: 500, category: 'needs' },
      { id: '112', name: 'School Supplies', amount: 100, category: 'needs' },
      { id: '113', name: 'Family Insurance', amount: 400, category: 'needs' },
      { id: '114', name: 'Groceries', amount: 800, category: 'needs' },
      { id: '115', name: 'Kids Clothing', amount: 200, category: 'needs' },
      { id: '116', name: 'Family Activities', amount: 300, category: 'wants' },
      { id: '117', name: 'Kids Sports', amount: 150, category: 'wants' },
      { id: '118', name: 'Family Entertainment', amount: 200, category: 'wants' },
      { id: '119', name: 'Family Vacation', amount: 300, category: 'wants' },
      { id: '120', name: 'Kids Hobbies', amount: 150, category: 'wants' },
      { id: '121', name: 'College Fund', amount: 500, category: 'savings' },
      { id: '122', name: 'Family Emergency', amount: 300, category: 'savings' },
      { id: '123', name: 'Kids Activities Fund', amount: 200, category: 'savings' },
      { id: '124', name: 'Future Education', amount: 200, category: 'savings' }
    ]
  },
  'newParent': {
    name: 'New Parent Budget',
    icon: Baby,
    description: 'A budget template for new parents adjusting to baby expenses.',
    fieldDescriptions: {
      needs: 'Baby essentials, healthcare, childcare',
      wants: 'Baby gear, toys, activities',
      savings: 'College fund, future expenses'
    },
    expenses: [
      { id: '125', name: 'Diapers', amount: 100, category: 'needs' },
      { id: '126', name: 'Formula/Food', amount: 200, category: 'needs' },
      { id: '127', name: 'Baby Healthcare', amount: 150, category: 'needs' },
      { id: '128', name: 'Childcare', amount: 1000, category: 'needs' },
      { id: '129', name: 'Baby Supplies', amount: 100, category: 'needs' },
      { id: '130', name: 'Baby Insurance', amount: 100, category: 'needs' },
      { id: '131', name: 'Baby Medicine', amount: 50, category: 'needs' },
      { id: '132', name: 'Baby Clothes', amount: 100, category: 'wants' },
      { id: '133', name: 'Toys', amount: 50, category: 'wants' },
      { id: '134', name: 'Books', amount: 30, category: 'wants' },
      { id: '135', name: 'Baby Classes', amount: 80, category: 'wants' },
      { id: '136', name: 'Photos/Memory Books', amount: 40, category: 'wants' },
      { id: '137', name: 'College Fund', amount: 200, category: 'savings' },
      { id: '138', name: 'Baby Emergency', amount: 150, category: 'savings' },
      { id: '139', name: 'Future Needs', amount: 100, category: 'savings' },
      { id: '140', name: 'Healthcare Fund', amount: 100, category: 'savings' }
    ]
  },
  'debtFree': {
    name: 'Debt Freedom',
    icon: Coins,
    description: 'A budget focused on aggressive debt repayment.',
    fieldDescriptions: {
      needs: 'Basic living expenses',
      wants: 'Minimal discretionary spending',
      savings: 'Debt payments, emergency fund'
    },
    expenses: [
      { id: '141', name: 'Basic Housing', amount: 800, category: 'needs' },
      { id: '142', name: 'Utilities', amount: 150, category: 'needs' },
      { id: '143', name: 'Basic Food', amount: 300, category: 'needs' },
      { id: '144', name: 'Basic Transport', amount: 100, category: 'needs' },
      { id: '145', name: 'Insurance', amount: 100, category: 'needs' },
      { id: '146', name: 'Phone Plan', amount: 40, category: 'needs' },
      { id: '147', name: 'Internet', amount: 50, category: 'needs' },
      { id: '148', name: 'Basic Entertainment', amount: 50, category: 'wants' },
      { id: '149', name: 'Minimal Dining', amount: 50, category: 'wants' },
      { id: '150', name: 'Basic Personal Care', amount: 30, category: 'wants' },
      { id: '151', name: 'Credit Card 1', amount: 500, category: 'savings' },
      { id: '152', name: 'Credit Card 2', amount: 400, category: 'savings' },
      { id: '153', name: 'Student Loan', amount: 300, category: 'savings' },
      { id: '154', name: 'Car Loan', amount: 300, category: 'savings' },
      { id: '155', name: 'Emergency Buffer', amount: 100, category: 'savings' }
    ]
  },
  'shopping': {
    name: 'Smart Shopper',
    icon: ShoppingBag,
    description: 'A budget optimized for regular shoppers with savings strategies.',
    fieldDescriptions: {
      needs: 'Essential shopping, groceries',
      wants: 'Clothing, electronics, hobbies',
      savings: 'Shopping fund, cashback savings'
    },
    expenses: [
      { id: '156', name: 'Groceries', amount: 400, category: 'needs' },
      { id: '157', name: 'Household Items', amount: 150, category: 'needs' },
      { id: '158', name: 'Personal Care', amount: 100, category: 'needs' },
      { id: '159', name: 'Basic Clothing', amount: 100, category: 'needs' },
      { id: '160', name: 'Cleaning Supplies', amount: 50, category: 'needs' },
      { id: '161', name: 'Health Products', amount: 75, category: 'needs' },
      { id: '162', name: 'Fashion', amount: 200, category: 'wants' },
      { id: '163', name: 'Electronics', amount: 150, category: 'wants' },
      { id: '164', name: 'Home Decor', amount: 100, category: 'wants' },
      { id: '165', name: 'Hobby Supplies', amount: 100, category: 'wants' },
      { id: '166', name: 'Accessories', amount: 50, category: 'wants' },
      { id: '167', name: 'Seasonal Items', amount: 75, category: 'wants' },
      { id: '168', name: 'Shopping Fund', amount: 200, category: 'savings' },
      { id: '169', name: 'Rewards Savings', amount: 100, category: 'savings' },
      { id: '170', name: 'Sale Purchases', amount: 150, category: 'savings' },
      { id: '171', name: 'Future Tech Fund', amount: 100, category: 'savings' }
    ]
  }
};